import React, { Component } from 'react';
import background from '../assets/img/Ae.png';


class Header extends Component {
    render () {
        return (
            <header aria-label="Informazioni e strumenti utente">
                <div id="agenzia-header" className="d-none d-md-block">
                    <div className="container-fluid py-md-1">
                        <p className="my-1"><a href=""></a></p>
                    </div>
                </div>
                <div id="page-header">
                    <div className="container-fluid py-3">
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <img src={background} alt="" className="logo" />
                            </div>
                            <div className="col">
                                <h1>Request for ID</h1>
                            </div>
                            <div className="col-auto">
                                <div className="d-lg-flex flex-lg-column header-links btn-rounded">
                                    <a href="https://www.agenziaentrate.gov.it/portale/web/english/nse/services/vat-mini-one-stop-shop/non-union-scheme" className="btn btn-primary btn-alt" title="Area di provenienza">
                                        <i className="fas fa-sign-out-alt fa-rotate-270"></i>
                                    </a>
                                    <a href="https://www.agenziaentrate.gov.it/portale/web/english/nse/services/vat-mini-one-stop-shop/help-desk" target="_blank" className="btn btn-primary btn-alt" title="Info e Assistenza">
                                        <i className="fas fa-info"></i><span className="sr-only">Info e Assistenza: apre una nuova finestra</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;